export interface LanguageLinkProps {
  label: string;
  href: string;
}

export const mobileLanguageLinks: Record<string, LanguageLinkProps[]> = {
  en: [
    {
      label: "Membership T&C's",
      href: 'https://mobiworkx.com/Account/MemberShipTerms?membershipTermID=6',
    },
    {
      label: 'Panel Privacy Policy',
      href: 'https://mobiworkx.com/Account/PanelPrivacyPolicy?privacyPolicyID=13',
    },
    {
      label: 'Rewards Program Terms',
      href: 'https://mobiworkx.com/Account/RewardsProgramTerms?rewardsProgramTermID=1',
    },
  ],
  ar: [
    {
      label: "Membership T&C's",
      href: 'https://mobiworkx.com/Account/MemberShipTerms?membershipTermID=9',
    },
    {
      label: 'Panel Privacy Policy',
      href: 'https://mobiworkx.com/Account/PanelPrivacyPolicy?privacyPolicyID=4',
    },
    {
      label: 'Rewards Program Terms',
      href: 'https://mobiworkx.com/Account/RewardsProgramTerms?rewardsProgramTermID=2',
    },
  ],
  hi: [
    {
      label: "Membership T&C's",
      href: 'https://mobiworkx.com/Account/MemberShipTerms?membershipTermID=11',
    },
    {
      label: 'Panel Privacy Policy',
      href: 'https://mobiworkx.com/Account/PanelPrivacyPolicy?privacyPolicyID=6',
    },
    {
      label: 'Rewards Program Terms',
      href: 'https://mobiworkx.com/Account/RewardsProgramTerms?rewardsProgramTermID=4',
    },
  ],
  fr: [
    {
      label: "Membership T&C's",
      href: 'https://mobiworkx.com/Account/MemberShipTerms?membershipTermID=16',
    },
    {
      label: 'Panel Privacy Policy',
      href: 'https://mobiworkx.com/Account/PanelPrivacyPolicy?privacyPolicyID=11',
    },
    {
      label: 'Rewards Program Terms',
      href: 'https://mobiworkx.com/Account/RewardsProgramTerms?rewardsProgramTermID=9',
    },
  ],
  bn: [
    {
      label: "Membership T&C's",
      href: 'https://mobiworkx.com/Account/MemberShipTerms?membershipTermID=17',
    },
    {
      label: 'Panel Privacy Policy',
      href: 'https://mobiworkx.com/Account/PanelPrivacyPolicy?privacyPolicyID=12',
    },
    {
      label: 'Rewards Program Terms',
      href: 'https://mobiworkx.com/Account/RewardsProgramTerms?rewardsProgramTermID=10',
    },
  ],
};
